import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, EyeOff } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Security() {
  const {
    t
  } = useLanguage();
  const items = [{
    icon: <EyeOff className="w-8 h-8" data-id="element-143" />,
    titleKey: 'security.item1.title',
    descKey: 'security.item1.desc'
  }, {
    icon: <Lock className="w-8 h-8" data-id="element-144" />,
    titleKey: 'security.item2.title',
    descKey: 'security.item2.desc'
  }, {
    icon: <Shield className="w-8 h-8" data-id="element-145" />,
    titleKey: 'security.item3.title',
    descKey: 'security.item3.desc'
  }];
  return <section className="py-32 bg-svt-bg relative overflow-hidden transition-colors duration-300" data-id="element-146">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-[300px] bg-svt-pink/5 blur-[100px] pointer-events-none" data-id="element-147"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-149">
          <h2 className="text-4xl md:text-5xl font-bold text-svt-text" data-id="element-150">
            {t('security.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-151">
              {t('security.title2')}
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-152">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="p-8 rounded-2xl bg-svt-surface border border-svt-border hover:bg-svt-surface-hover transition-colors flex flex-col items-center text-center group" data-id="element-153">
              <div className="w-16 h-16 rounded-full bg-svt-pink/10 text-svt-pink flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-154">
                {item.icon}
              </div>
              <h3 className="text-sm font-semibold mb-2 text-svt-text" data-id="element-155">
                {t(item.titleKey)}
              </h3>
              <p className="text-sm text-svt-text-faint font-light" data-id="element-156">
                {t(item.descKey)}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}